/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MedicationViewerAliases {
  ADJUST_INFUSION_SPEED_BUTTON_PANEL = 'adjust-infusion-speed-button-panel',
  ADJUST_INFUSION_SPEED_BUTTON_PANEL_PADDING = 'adjust-infusion-speed-button-panel-padding',
  ADMINISTRATION_BY_PROCESS_ACTION = 'administration-by-process-action',
  ADMINISTRATION_BY_SCHEDULE_ACTION = 'administration-by-schedule-action',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  MEDICATION_OR_SOLUTION_DETAILS_CARD = 'medication-or-solution-details-card',
  MEDICATION_VIEWER_BUTTON = 'medication-viewer-button',
  MEDICATION_VIEWER_CONTENT_PANEL = 'medication-viewer-content-panel',
  MEDICATION_VIEWER_CONTEXTUAL_BAR = 'medication-viewer-contextual-bar',
  MEDICATION_VIEWER_CONTEXTUAL_BAR_ACTION = 'medication-viewer-contextual-bar-action',
  MEDICATION_VIEWER_CONTEXTUAL_BAR_ACTION_SUSPEND = 'medication-viewer-contextual-bar-action-suspend',
  MEDICATION_VIEWER_DECK = 'medication-viewer-deck',
  MEDICATION_VIEWER_LAYOUT = 'medication-viewer-layout',
  MEDICATION_VIEWER_PANEL_BUTTON = 'medication-viewer-panel-button',
  PANEL_HEADER = 'panel-header',
  REVERSE_ADMINISTRATION = 'reverse-administration',
  SCHEDULE_MEDICATION = 'schedule-medication',
}
export { MedicationViewerAliases };
